import {
    Component,
    ElementRef,
    HostBinding,
    OnInit,
    ViewChild,
} from '@angular/core';
import { SettingsQuery } from '../../../../shared/state/settings/settings.query';
import { SettingsService } from '../../../../shared/state/settings/settings.service';
import { Router } from '@angular/router';
import { ClinicQuery } from '../../../../shared/state/clinic/clinic.query';
import { ClinicService } from '../../../../shared/state/clinic/clinic.service';
import { Observable } from 'rxjs';
import { Clinic } from '../../../../shared/state/clinic/clinic.store';
import { LibraryService } from '../../../../core/services/library/library.service';
import { Capacitor } from '@capacitor/core';
import { CompanyService } from '../../../../shared/state/company/company.service';
import { HeaderBackgroundQuery } from '../../../../shared/state/header-background/header-background.query';
import { AlertController, Platform, ViewWillEnter } from '@ionic/angular';
import { Keyboard } from '@capacitor/keyboard';
import { HeaderComponent } from 'src/app/shared/components/header/header.component';
import { fade_in, fade_out } from 'src/app/core/animations/fade';
import { CompanyQuery } from 'src/app/shared/state/company/company.query';
import { HeaderDesktopComponent } from 'src/app/shared/components/header-desktop/header-desktop.component';
import { filter, take } from 'rxjs/operators';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-generic',
    animations: [fade_out, fade_in],
    templateUrl: './generic.component.html',
    styleUrls: ['./generic.component.scss'],
})
export class GenericComponent implements OnInit, ViewWillEnter {
    clinics$: Observable<Clinic[]>;
    isLoadingContent = false;
    isSearchingClinic = false;
    clinicsLoading$ = this.clinicQuery.selectLoading();
    currentGenericKey$: Observable<number>;
    headerBackground$;
    isBrowser$: Observable<boolean>;
    searched = false;

    /** Flowwwer template */
    clinicsDynamic$: Observable<Clinic[]>;
    clinicsFav$: Observable<Clinic[]>;
    labelClinicList = '';
    mapActive = false;
    clinicNearestSearched = false;

    @HostBinding('class.backgroundFixed') backgroundFixed = false;

    /** Flowwwer template */
    @ViewChild(HeaderComponent)
    headerComponent: HeaderComponent;
    @ViewChild(HeaderDesktopComponent)
    headerDesktopComponent: HeaderDesktopComponent;
    clinicCurrentListType: ClinicDynamicListType;
    CLINIC_DYNAMIC_LIST_TYPE_CLINICS_NEAREST =
        ClinicDynamicListType.CLINICS_NEAREST;
    CLINIC_DYNAMIC_LIST_TYPE_CLINICS_FOUND =
        ClinicDynamicListType.CLINICS_FOUND;
    CLINIC_DYNAMIC_LIST_TYPE_CLINICS_LATEST_RESULT =
        ClinicDynamicListType.CLINICS_LATESST_RESULT;

    public mapsSrc: SafeUrl = '';

    constructor(
        private settingsQuery: SettingsQuery,
        private settingService: SettingsService,
        private clinicQuery: ClinicQuery,
        private clinicService: ClinicService,
        private router: Router,
        private libraryService: LibraryService,
        private elRef: ElementRef,
        private companyService: CompanyService,
        private headerBackgroundQuery: HeaderBackgroundQuery,
        private alertCtrl: AlertController,
        private platform: Platform,
        private companyQuery: CompanyQuery,
        private sanitizer: DomSanitizer
    ) {
        // @ts-ignore
        window.initMapGeneric = () => {
            this.initScriptMap();
        };
    }

    async ngOnInit(): Promise<void> {
        if (Capacitor.isNativePlatform()) {
            this.backgroundFixed = true;
        }

        this.currentGenericKey$ = this.settingsQuery.select('genericKey');
        this.headerBackground$ = this.headerBackgroundQuery.select('home');
        this.isBrowser$ = this.settingsQuery.select('browser');
    }

    ionViewWillEnter() {
        this.isLoadingContent = true;

        /** Borramos la librería de la clínica personalizada para dejar solo las labels offline */
        this.libraryService.removeCompnayLibrary();
    }

    /** Cuando hemos entrado en la pantalla, tenemos que cambiar siempre los colores cuando volvemos de una clínica */
    ionViewDidEnter() {
        /** Destruimos la store de la company ya que estamos en el buscador genérico */
        this.companyService.resetStore();
        this.settingService.updateParentSystemKey('');
        this.initClinicListPage();
    }

    /** Inicializamos el listado de clínicas */
    async initClinicListPage(event?) {
        /** Flowwwer template */
        //TODO, VER esto porque es lento
        this.headerComponent?.resetSearch();
        this.headerDesktopComponent?.clearSearchInput();

        /** Cargamos App Genérica */
        this.settingService.initGenericApp();
        this.clinics$ = this.clinicQuery.select('clinicsFound');

        /** Flowwwer template */
        this.libraryService
            .getLabelStream(
                //TODO: Esta label no la tiene por lo que sea al principio... tengo que cargarla de forma asíncrona
                'lbl_clinics_nearest'
            )
            .subscribe((label) => {
                this.labelClinicList = label;
            });

        if(!this.clinicQuery.clinicNearest.length || event){
            this.clinicService
                .findClinicsNearest()
                .then(() => (this.clinicNearestSearched = true));
            this.clinicsDynamic$ = this.clinicQuery.select('clinicsNearest');
        }
        
        this.clinicCurrentListType = ClinicDynamicListType.CLINICS_NEAREST;

        this.clinicService.loadClinicsLatestResultsFromLocalStorage();
        this.clinicsFav$ = this.clinicQuery.select('clinicsFav');
        this.isLoadingContent = false;
        event.target.complete();
    }

    onKeyPressed(event) {
        if (event.keyCode === 13) {
            this.hideKeyboard();
            const input = this.elRef.nativeElement.getElementsByTagName(
                'input'
            );
            input[0].blur();
            this.searchClinics(event.target.value);
        }
    }

    hideKeyboard() {
        if (Capacitor.isNativePlatform()) {
            Keyboard.hide();
        }
    }

    /** Función que busca clínicas en una APP Genérica mediante API mediante una key */
    async searchClinics(searchText) {
        this.isSearchingClinic = true;
        this.searched = true;
        await this.clinicService.findClinicsByKey(searchText);
        this.isSearchingClinic = false;
    }

    /** Esta función se usa para seleccionar una clínica (bien por click o bien programaticamente
     * Una vez la clínica está inicializada en la Store va a la pantalla de clínica
     */
    selectClinic(clinic: Clinic) {
        this.router.navigate([clinic.systemKey + '/' + clinic.id + '/details']);
    }

    /** Función que se llama cuando se pulsa en una clínica en el listado */
    onClinicClicked(clinic: Clinic) {
        this.selectClinic(clinic);
    }

    /** Flowwwer template */
    headerShowSearch() {
        this.labelClinicList = this.libraryService.getLabel(
            'lbl_clinics_latest_results'
        );
        this.clinicsDynamic$ = this.clinicQuery.select('clinicsLatestResults');
     
        this.clinicCurrentListType =
            ClinicDynamicListType.CLINICS_LATESST_RESULT;
    }

    headerHideSearch() {
        this.labelClinicList = this.libraryService.getLabel(
            'lbl_clinics_nearest'
        );
        this.clinicsDynamic$ = this.clinicQuery.select('clinicsNearest');
        
        this.clinicCurrentListType = ClinicDynamicListType.CLINICS_NEAREST;
    }

    async headerSearchClinic(text: string) {
        await this.searchClinics(text);
        this.labelClinicList = this.libraryService
            .getLabel('lbl_clinics_results_count')
            .replace(
                '###NUM###',
                this.clinicQuery.getValue().clinicsFound.length.toString()
            );
        this.clinicsDynamic$ = this.clinicQuery.select('clinicsFound');
      
        this.clinicCurrentListType = ClinicDynamicListType.CLINICS_FOUND;
    }

    async showConfirmClearLatestResult() {
        const alert = await this.alertCtrl.create({
            mode: this.platform.is('android') ? 'md' : 'ios',
            message: this.libraryService.getLabel(
                'lbl_confirm_clear_latest_result'
            ),
            buttons: [
                {
                    text: this.libraryService.getLabel('app_action_delete'),
                    role: 'confirm',
                    handler: () => {
                        this.clinicService.clearClinicsLatestResults();
                    },
                },
                {
                    text: this.libraryService.getLabel('app_action_cancel'),
                    role: 'cancel',
                },
            ],
        });
        await alert.present();
    }

    initScriptMap(): void {
        this.mapsSrc = this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.google.com/maps/embed/v1/place?key=${environment.googleMapsApiKey}&q=${this.settingsQuery.latitude},${this.settingsQuery.longitude}&zoom=18`);
    }
}

enum ClinicDynamicListType {
    CLINICS_NEAREST,
    CLINICS_LATESST_RESULT,
    CLINICS_FOUND,
}
